import {
  CircleCloseIcon,
  CirclesIcon,
  ConeIcon,
  ExclamationIcon,
  LockIcon,
  TechModeIcon,
} from '@smartshell/ui-kit';

import { EShellMode } from 'types';

import { IHostState, GetHostsResponse } from './interfaces';

export const getHostState = (
  host: GetHostsResponse['hostOverview']
): IHostState | null => {
  if (host.locked) {
    return { Icon: LockIcon };
  }

  if (host.shell_mode !== EShellMode.NORMAL) {
    switch (host.shell_mode) {
      case EShellMode.HIGH_ACCESS:
        return { color: '#FF3636', Icon: TechModeIcon };
      case EShellMode.DISABLED:
        return { color: '#FF3636', Icon: CircleCloseIcon };
    }
  }

  if (host.device_has_changed) {
    return { color: '#FF7E36', Icon: CirclesIcon, hideBG: true };
  }

  if (host.in_service) {
    return { color: '#FF7E36', Icon: ConeIcon };
  }

  if (host.client_sessions.length) {
    if (!host.online) {
      return { color: '#FF3636', Icon: ExclamationIcon };
    }
  }

  return null;
};
